var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"monthCalendar"},[_c('full-calendar',{ref:"calendar",attrs:{"config":_vm.config,"header":_vm.header,"event-sources":_vm.eventSources},on:{"event-selected":_vm.eventSelected,"event-created":_vm.eventCreated}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44c36678","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pagesPc/main/component/monthCalendar.vue
// module id = null
// module chunks = 